import { Scale, FileText, Building2, ShieldCheck } from "lucide-react";

const ITEMS = [
  { icon: FileText, label: "Art. L. 221-1-2 du Code de la Sécurité sociale" },
  { icon: Scale, label: "Loi n° 2023-270 du 14 avril 2023" },
  { icon: Building2, label: "Fonds géré par la CARSAT — Assurance Maladie" },
  { icon: ShieldCheck, label: "Dispositif vérifiable sur ameli.fr" },
];

export default function InstitutionalBand() {
  return (
    <section className="bg-white border-y pc-line" aria-label="Cadre légal">
      <div className="mx-auto max-w-6xl px-5 lg:px-8 py-8">
        <div className="flex items-center gap-3 mb-5">
          <span className="tricolor-stripe !h-2.5" aria-hidden />
          <span className="text-[10.5px] tracking-[0.22em] uppercase pc-text-muted font-semibold">
            Cadre légal du dispositif
          </span>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-3">
          {ITEMS.map((it) => {
            const Icon = it.icon;
            return (
              <div key={it.label} className="flex items-start gap-2.5 text-[13px] pc-text-ink leading-[1.4]">
                <Icon className="w-4 h-4 pc-text-blue shrink-0 mt-[2px]" strokeWidth={1.8} />
                <span>{it.label}</span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
